export const TOOLTIP_DELAY = 300;